import { Injectable, Inject } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/core/services/data.service';

@Injectable({
	providedIn: 'root',
})
export class DisposService {
	constructor(private utils: UtilsService, private http: HttpClient, private dataSrv: DataService) {}

	saveDispo(payload): Observable<any> {
		var formData: any = new FormData();
		formData = this.utils.jsonToFormData(payload);
		const url: string = `${environment.api}caller/dispos/save_dispo`;
		return this.http.post(url, formData);
	}

	saveLead(payload): Observable<any> {
		var formData: any = new FormData();
		formData = this.utils.jsonToFormData(payload);
		const url: string = `${environment.api}caller/dispos/save_lead`;
		return this.http.post(url, formData);
	}

	setCallbackAsCalled(dispoId: number) {
		const url = environment.api + 'dispos/set_callback_called.php';
		return this.dataSrv.post(url, { dispoId: dispoId });
	}

	hotCallBack(dispo: any): Observable<any> {
		const url: string = `${environment.api}dispos/hot_call_back`;
		const formData: any = this.utils.jsonToFormData(dispo);
		return this.http.post(url, formData);
	}

	updateProspect(prospect: any) {
		const url = `${environment.api}dispos/update_prospect`;

		const formData = new FormData();
		Object.entries(prospect).forEach(([key, value]) => {
			formData.append(key, String(value ?? ''));
		});

		return this.dataSrv.postObservableSimple(url, formData);
	}
	saveCalendar(payload): Observable<any> {
		var formData: any = new FormData();
		formData = this.utils.jsonToFormData(payload);
		const url: string = `${environment.api}caller/dispos/save_calendar`;
		return this.http.post(url, formData);
	}
}
